/**
 * @generated SignedSource<<62fab7d1d7ccdb7975c5fe3f8945ff72>>
 * @relayHash 1ff4ca03c384b08512cbe580492073d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3212d8515f02f63ecb6e64f5cf8c67c56a9b0f6f70d016e539ae93df5099a9af

import type { ConcreteRequest } from 'relay-runtime';
export type TemplateListTemplateCategoriesQuery$variables = {
  spaceKey: string;
};
export type TemplateListTemplateCategoriesQuery$data = {
  readonly templateCategories: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type TemplateListTemplateCategoriesQuery = {
  response: TemplateListTemplateCategoriesQuery$data;
  variables: TemplateListTemplateCategoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "PaginatedTemplateCategoryList",
    "kind": "LinkedField",
    "name": "templateCategories",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateCategory",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TemplateListTemplateCategoriesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TemplateListTemplateCategoriesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1ff4ca03c384b08512cbe580492073d6",
    "id": "3212d8515f02f63ecb6e64f5cf8c67c56a9b0f6f70d016e539ae93df5099a9af",
    "metadata": {},
    "name": "TemplateListTemplateCategoriesQuery",
    "operationKind": "query",
    "text": "query TemplateListTemplateCategoriesQuery($spaceKey:String!){templateCategories(spaceKey:$spaceKey){nodes{id,name}}}"
  }
};
})();

(node as any).hash = "8274b7258189f7803410cd51d5891f52";

export default node;
